import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-four-o-four',
    templateUrl: './four-o-four.component.html',
    styleUrls: ['./four-o-four.component.scss'],
    standalone: false
})
export class FourOFourComponent {
  constructor(private router: Router) {}

  goBack(): void { 
    // Navigate to My Projects page instead of browser back
    this.router.navigate(['/workspace/my-projects']);
  }
}
